import React from 'react'
import { Arrow } from 'app/assets/icons'
import { media } from 'app/assets/styles'
import BlazonSticker from 'app/common/blazon/sticker/BlazonSticker'
import type { BreadcrumbElement } from 'app/common/breadcrumb'
import { Breadcrumb } from 'app/common/breadcrumb'
import { Link } from 'app/common/link'
import { H2, Text } from 'app/common/typography'
import type { Element } from 'react'
import styled from 'styled-components'

type Props = {
    url: string,
    title: string,
    breadcrumb?: Array<BreadcrumbElement>,
    description?: string,
    icon?: Element<any>,
    blazonProfileImageUrl?: string
}

const HeadTitle = (props: Props) => {
    const {
        breadcrumb,
        description,
        icon,
        url,
        title,
        blazonProfileImageUrl
    } = props

    return (
        <Root>
            {breadcrumb && <Breadcrumb breadcrumbArray={breadcrumb} />}
            <RowContainer>
                {url && blazonProfileImageUrl && (
                    <LinkContainer>
                        <Link url={url}>
                            <Arrow />
                        </Link>
                    </LinkContainer>
                )}
                {blazonProfileImageUrl && (
                    <BlazonStickerContainer>
                        <BlazonSticker imageUrl={blazonProfileImageUrl} />
                    </BlazonStickerContainer>
                )}
                <TextContainer>
                    <TitleContainer blazon={blazonProfileImageUrl}>
                        {url && !blazonProfileImageUrl && (
                            <LinkContainer>
                                <Link url={url}>
                                    <Arrow />
                                </Link>
                            </LinkContainer>
                        )}
                        <StyledH2>{title}</StyledH2>
                        <IconContainer>{icon}</IconContainer>
                    </TitleContainer>
                    {description && (
                        <Description blazon={blazonProfileImageUrl}>
                            <Text>{description}</Text>
                        </Description>
                    )}
                </TextContainer>
            </RowContainer>
        </Root>
    )
}

const Root = styled.div`
    margin: 20px 0;
    ${media.medium`
        margin: 10px 0;
        width: 100%;
    `};
`

const BlazonStickerContainer = styled.div`
    flex-shrink: 0;
`

const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 14px;
    ${media.small`
        gap: 28px;
    `};
    width: 100%;
`

const TextContainer = styled.div`
    width: 100%;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: ${({ blazon }) =>
        blazon ? 'flex-start' : 'space-between'};
    width: 100%;
`

const IconContainer = styled.div`
    cursor: pointer;
    ${media.medium`
        margin-left: 20px;
    `};
`

const LinkContainer = styled.div`
    ${media.medium`
        display: none;
    `};
`

const StyledH2 = styled(H2)`
    text-align: left;
    ${media.medium`
        margin-top: 0;
    `};
`

const Description = styled.p`
    text-align: ${({ blazon }) => (blazon ? 'start' : 'center')};
    ${media.medium`
        text-align: start;
    `};
`

export { HeadTitle }
